// src/Redux/Slice/SubTask.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;

// --- Asynchronous Thunks ---

/*  Thunk to fetch sub-task data from the API.*/
export const ShowAllSubTask = createAsyncThunk(
    'TaskMaster/fetchSubTaskData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/SubTaskMaster/SubTaskFind`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Add SubTask 
export const addSubTaskMember = createAsyncThunk(
    "SubTaskMaster/addSubTaskMember",
    async ({ Data, member }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/SubTaskMaster`, {
                SubTaskName: Data,
                TeamId: member,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Update SubTask by Id
export const updateSubTask = createAsyncThunk(
    "SubTaskMaster/updateSubTask",
    async ({ id, subTaskName, memberIds }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/SubTaskMaster/SubTaskUpdate/${id}`, {
                SubTaskName: subTaskName,
                TeamId: memberIds,
            });

            return response.data; // success response
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Thunk to fetch sub-task by ID from the API
export const fetchSubTaskById = createAsyncThunk(
    'TaskMaster/fetchSubTaskById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/SubTaskMaster/PSubTaskfindId/${id}`);
            return response.data; // Return just the data (not full Axios response)
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// Thunk to delete a sub-task by ID
export const DeleteSubTaskById = createAsyncThunk(
    'TaskMaster/deleteSubTaskById',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/SubTaskMaster/SubTaskdelete/${id}`);
            const data = response.data;

            if (data.status === "SubTask Success Delete") {
                return data;
            } else {
                return rejectWithValue("SubTask Assigning in MainTask, please remove it from task master.");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


// --- Redux Slice ---

const SubTask = createSlice({
    name: 'subtask',
    initialState: {
        // SubTask Data State
        AllSubTaskData: [],
        subTaskLoading: false,
        subTaskError: null,

        AddSubTask: [],
        addSubtaskLoading: false,
        addSubtaskError: null,

        SubTaskByIdData: [],
        SubTaskByIdLoading: false,
        SubTaskByIdError: null,


        DeleteSubTask: null,
        deleteSubTaskLoading: false,
        deleteSubTaskError: null,

        UpdateSubTaskData: null,
        updateSubTaskLoading: false,
        updateSubTaskError: null,
    },
    reducers: {
        // You can add synchronous reducers here if needed
        resetCreateTaskStatus: (state) => {
            state.createTaskStatus = 'idle';
            state.createTaskError = null;
            state.createdTask = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // --- SubTask Data Handlers ---
            .addCase(ShowAllSubTask.pending, (state) => {
                state.subTaskLoading = true;
                state.subTaskError = null;
            })
            .addCase(ShowAllSubTask.fulfilled, (state, action) => {
                state.subTaskLoading = false;
                state.AllSubTaskData = action.payload;
            })
            .addCase(ShowAllSubTask.rejected, (state, action) => {
                state.subTaskLoading = false;
                state.subTaskError = action.payload;
            })

            // --- SubTask Data Handlers ---
            .addCase(addSubTaskMember.pending, (state) => {
                state.addSubtaskLoading = true;
                state.addSubtaskError = null;
            })
            .addCase(addSubTaskMember.fulfilled, (state, action) => {
                state.addSubtaskLoading = false;
                state.AddSubTask = action.payload;
            })
            .addCase(addSubTaskMember.rejected, (state, action) => {
                state.addSubtaskLoading = false;
                state.addSubtaskError = action.payload;
            })

            // --- SubTask Data by ID Handlers ---
            .addCase(fetchSubTaskById.pending, (state) => {
                state.SubTaskByIdLoading = true;
                state.SubTaskByIdError = null;
            })
            .addCase(fetchSubTaskById.fulfilled, (state, action) => {
                state.SubTaskByIdLoading = false;
                state.SubTaskByIdData = action.payload;
            })
            .addCase(fetchSubTaskById.rejected, (state, action) => {
                state.SubTaskByIdLoading = false;
                state.SubTaskByIdError = action.payload;
            })

            // --- Delete SubTask by ID Handlers ---
            .addCase(DeleteSubTaskById.pending, (state) => {
                state.deleteSubTaskLoading = true;
                state.deleteSubTaskError = null;
            })
            .addCase(DeleteSubTaskById.fulfilled, (state, action) => {
                state.deleteSubTaskLoading = false;
                state.DeleteSubTask = action.payload;
            })
            .addCase(DeleteSubTaskById.rejected, (state, action) => {
                state.deleteSubTaskLoading = false;
                state.deleteSubTaskError = action.payload;
            })

            // --- Update SubTask by ID Handlers ---
            .addCase(updateSubTask.pending, (state) => {
                state.updateSubTaskLoading = true;
                state.updateSubTaskError = null;
            })
            .addCase(updateSubTask.fulfilled, (state, action) => {
                state.updateSubTaskLoading = false;
                state.UpdateSubTaskData = action.payload;
            })
            .addCase(updateSubTask.rejected, (state, action) => {
                state.updateSubTaskLoading = false;
                state.updateSubTaskError = action.payload;
            })
    }
});

// Export any actions you define in `reducers`
export const { resetCreateTaskStatus } = SubTask.actions;

// Export the reducer
export default SubTask.reducer;